export default {
      id: "link-usage",
      viewBox: "0 0 13 12",
      url: __webpack_public_path__ + "sprite.1790164512331.svg#link-usage",
      toString: function () {
        return this.url;
      }
    }